import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import classNames from 'classnames';

export default styled(props => <Link {...props} className={classNames(props.className, 'back-button')}>
    <img alt="" src={'/images/icon_down@3x.png'} />
    <span>
      BACK TO ALL
    </span>
  </Link>)`
    border: solid 1px #b6b8bc;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transform: rotate(-90deg);
    width: 287px;
    height: 48px;
    left: -119px;
    text-decoration: none;
    background-color: #363b41;
  
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
  
    img{
      width: 10px;
      margin-left: 58px;
      transform: rotate(180deg);
      margin-right: 30px;
      margin-left: -13px;
    }
    span{
      font-family: Lato;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: 0.6px;
      text-align: center;
      color: #b6b8bc;
    }
  `;